import {DokumentVersjonModell, HttpsUrl, VirussjekkStatus} from "./ressurser/generertNg2HttpKlient";
import {Injectable} from "@angular/core";
import {erGenerertDokument, standardDokumentNavn} from "felles-ng2/modell/dokumentModellHjelpere";
import {finnMimeinfoBasertPåMimetypeMedFallback, Mimeinfo, mimetyper} from "felles-ng2/støttefunksjoner/mimetyper";
import {RessursAdresser} from "felles-ng2/tjenester/ressurser/RessursAdresser";


@Injectable({providedIn: 'root'})
export class DokumentInformasjonTjeneste {

    constructor(private ressursAdresser: RessursAdresser) {
    }

    /** Returnerer diverse informasjon avledet av angitt dokumentversjon. */
    dokumentinformasjon(dokumentversjon: DokumentVersjonModell): DokumentInformasjon {
        let orginalFormat = finnMimeinfoBasertPåMimetypeMedFallback(dokumentversjon.orginalformat);
        const orginalFormatInfo = this.formatInfo(dokumentversjon, dokumentversjon.filnavn, orginalFormat);
        let standardformat = orginalFormatInfo;

        let formater = [orginalFormatInfo];
        if (dokumentversjon.harPdfRepresentasjon) {
            standardformat = this.formatInfo(dokumentversjon, dokumentversjon.pdfFilnavn!, mimetyper.pdf);
            if (orginalFormat !== mimetyper.pdf) formater.push(standardformat);
        }

        const pdfViserUrl = this.ressursAdresser.pdfjsDokumentViserUrl(dokumentversjon);
        return {
            standardnavn: standardDokumentNavn(dokumentversjon),
            virussjekkPaagaar: dokumentversjon.virussjekkStatus == VirussjekkStatus.ikke_sjekket,
            infisert: dokumentversjon.virussjekkStatus == VirussjekkStatus.infisert,
            forsideUrl: this.ressursAdresser.dokumentForsideUrl(dokumentversjon),
            formater: formater,
            multipleFormater: formater.length > 1,
            standardformat: standardformat,
            orginalFormat: orginalFormatInfo,
            standardUrl: dokumentversjon.harPdfRepresentasjon ? pdfViserUrl : orginalFormatInfo.url,
            pdfjsDokumentViserUrl: pdfViserUrl,
            erGenerert: erGenerertDokument(dokumentversjon),
            inlineVisningMulig: dokumentversjon.virussjekkStatus != VirussjekkStatus.infisert && dokumentversjon.harPdfRepresentasjon
        };
    }


    //private hjelpemetoder

    private formatInfo(dokumentversjon: DokumentVersjonModell, filnavn: string, mimeInfo: Mimeinfo): DokumentFormatInfo {
        return {
            filnavn: filnavn,
            mimeinfo: mimeInfo,
            url: this.ressursAdresser.dokumentUrl(dokumentversjon.id, mimeInfo.mimetype, filnavn)
        };
    }
}


export interface DokumentInformasjon {
    /** Pdf-filnavn dersom pdf-representasjon finnes, eller originalt filnavn */
    standardnavn: string;
    virussjekkPaagaar: boolean;
    infisert: boolean;
    forsideUrl: HttpsUrl;
    formater: DokumentFormatInfo[];
    multipleFormater: boolean;
    standardformat: DokumentFormatInfo;
    orginalFormat: DokumentFormatInfo;
    /** Url som kan benyttes for å vise dokument, dersom dokumentet er i PDF-format vil denne være lik {@link #pdfjsDokumentViserUrl} */
    standardUrl: HttpsUrl;
    /** Url som kan benyttes for å vise dokument dersom dokument er i PDF-format */
    pdfjsDokumentViserUrl: HttpsUrl;
    /** Sann dersom dokumentet er et generert dokument, slik som protokoll, agenda etc */
    erGenerert: boolean;
    /** Sann dersom dokumentet ikke er virus-infisert og er i PDF-format */
    inlineVisningMulig: boolean;

    /* formatFor(mimetype: string): DokumentFormatInfo {
         return this.formater.find(format => format.mimeinfo.mimetype === mimetype);
     }*/
}

export interface DokumentFormatInfo {
    filnavn: string;
    mimeinfo: Mimeinfo;
    url: HttpsUrl;
}
